<template>
    <div>

        <el-drawer :visible.sync="drawer" :withHeader="false" :direction="direction">
            <div class="container mt-3">
                <div class="row">
                    <div class="col-md-12 text-center">
                        <span><img class="img-fluid" src="@/assets/logo.png" alt=""></span>
                        <hr />
                    </div>
                    <div class="col-md-12">
                        <el-menu class="el-menu-vertical-demo">
                            <template v-if="level==0">
                                <el-menu-item index="1">
                                    <router-link class="nav-link click menu-items" to="/Home">
                                        <i class="fas fa-home mr-3"></i> Home
                                    </router-link>
                                </el-menu-item>
                            </template>
                            <template v-if="level==0 | level==1">
                                <el-menu-item index="2">
                                    <router-link class="nav-link click menu-items" to="/Main">
                                        <i class="fas fa-microchip mr-3"></i> My Stations
                                    </router-link>
                                </el-menu-item>
                            </template>
                            <template v-if="level==0 | level==1">
                                <el-menu-item index="3">
                                    <router-link class="nav-link click menu-items" to="/nested-stations">
                                        <i class="fas fa-sim-card mr-3"></i> Nested stations
                                    </router-link>
                                </el-menu-item>
                            </template>
                            <template v-if="level==0 | level==1">
                                <el-menu-item index="4">
                                    <router-link class="nav-link click menu-items" to="/manual-records">
                                        <i class="far fa-hand-spock mr-3"></i> Manual Records
                                    </router-link>
                                </el-menu-item>
                            </template>
                            <template v-if="level==0 | level==1">
                                <el-menu-item index="5">
                                    <router-link class="nav-link click menu-items" to="/lightning-strikes">
                                        <i class="fas fa-cloud-sun mr-3"></i> Internet Weather
                                    </router-link>
                                </el-menu-item>
                            </template>
                            <template v-if="level==0 | level==1">
                                <el-menu-item index="6">
                                    <router-link class="nav-link click menu-items" to="/droplets">
                                        <i class="fas fa-tint mr-3"></i> Droplets
                                    </router-link>
                                </el-menu-item>
                            </template>
                            <template v-if="level==0 | level==2">
                                <el-menu-item index="7">
                                        <router-link class="nav-link click menu-items" to="/qr">
                                            <i class="fas fa-qrcode mr-3"></i> Inventory
                                        </router-link>
                                </el-menu-item>
                            </template>
                            <template v-if="level==0 | level==2">
                                <el-menu-item index="8">
                                        <router-link class="nav-link click menu-items" to="/repairs">
                                            <vs-icon class="mr-3" icon="hardware"></vs-icon> In-Office Work Orders
                                        </router-link>
                                </el-menu-item>
                            </template>
                            <template v-if="level==0 | level==2">
                                <el-menu-item index="8">
                                        <router-link class="nav-link click menu-items" to="/field">
                                            <vs-icon class="mr-3" icon="park"></vs-icon> Field Work Orders
                                        </router-link>
                                </el-menu-item>
                            </template>
                            <template v-if="level==0">
                                <el-menu-item index="9">
                                    <router-link class="nav-link click menu-items" to="/Ids">
                                        <i class="fas fa-code mr-3"></i> API IDs
                                    </router-link>
                                </el-menu-item>
                            </template>
                            <vs-divider></vs-divider>


                            <el-menu-item index="10">
                                <span @click="logOut" class="nav-link click menu-items"><i
                                        class="fas fa-chevron-left mr-3"></i> Logout</span>
                            </el-menu-item>
                        </el-menu>
                    </div>
                </div>
            </div>
        </el-drawer>


        <nav class="navbar navbar-expand-sm  navbar-dark navbar-expand-md  justify-content-left">
            <!-- <a class="navbar-brand"><img class="img-fluid" src="@/assets/logo.png" width="120"></a> -->
            <el-button size="mini" round>
                <i class="fas fa-chevron-right"></i> {{selectedPath}}
            </el-button>
            <el-button size="mini" round>
                <i class="fa fa-user"></i> {{name}}
            </el-button>
            <vs-button @click="drawer = true" icon="view_module" color="dark" type="line"></vs-button>
        </nav>


        <!-- <vs-sidebar parent="body" default-index="1" color="dark" class="sidebarx" spacer v-model="status">
            <div class="header-sidebar" slot="header">
                <img class="img-fluid" src="@/assets/logo.png" width="150">
            </div>
            <vs-sidebar-item index="1">
                <router-link class="nav-link click" to="/Home">
                    <i class="fas fa-home mr-3"></i> Home
                </router-link>
                <span class="nav-link click" @click="handleClick('Home')">
                    <i class="fas fa-home mr-3"></i> Home
                </span>
            </vs-sidebar-item>
            <vs-sidebar-item index="2">
                <router-link class="nav-link click" to="/Main" @click="status=!status">
                    <i class="fas fa-microchip mr-3"></i> My Stations
                </router-link>
                <span class="nav-link click" @click="handleClick('Main')">
                    <i class="fas fa-microchip mr-3"></i> My Stations
                </span>
            </vs-sidebar-item>
            <vs-sidebar-item index="3">
                <i class="fas fa-sim-card mr-3"></i> Nested stations
            </vs-sidebar-item>
            <vs-sidebar-item index="4">
                <i class="far fa-hand-spock mr-3"></i> Manual Records
            </vs-sidebar-item>
            <vs-sidebar-item index="5">
                <i class="fas fa-cloud-sun mr-3"></i> Internet Weather
            </vs-sidebar-item>
            <vs-sidebar-item index="6">
                <i class="fas fa-tint mr-3"></i> Droplets
            </vs-sidebar-item>
            <vs-sidebar-item index="7">
                <i class="fas fa-qrcode mr-3"></i> Qr Tags
            </vs-sidebar-item>
            <vs-sidebar-item index="8">
                <i class="fas fa-code mr-3"></i> API IDs
            </vs-sidebar-item>

            <div class="footer-sidebar" slot="footer">
                <vs-button icon="reply" color="danger" type="flat">log out</vs-button>
            </div>
        </vs-sidebar> -->
    </div>

    </div>
</template>

<script>
    import { firebaseApp } from "../fb";
    export default {
        name: 'home',
        data() {
            return {
                drawer: false,
                direction: 'ltr',
                url: '',
                apiNickname: '',
                user: '',
                name: '',
                apiObject: [],
                apiObjectLength: 0,
                editName: '',
                editApi: '',
                editIndex: '',
                dbname: '',
                dbpass: '',
                dbuser: '',
                lvl: false,
                level: 0,
                apiOrigin: false,
                popupNest: false,
                selectedName: '',
                apiName: '',
                apiValue: '',
                selectedPath: '',
                colorx: '#3DC9B3',
            };
        },
        mounted() {
            this.getInitialData();
            this.selectedPath = this.$route.name

        },
        crated() {
        },
        methods: {
            logOut() {
                this.loading = false
                firebaseApp.auth().signOut()
            },
            getInitialData() {
                var vm = this
                vm.apiObject = []
                firebaseApp.auth().onAuthStateChanged(function (user) {
                    if (!user) {
                        vm.$router.push('/');
                    } else {
                        vm.user = user.uid
                        firebaseApp.database().ref('users/' + user.uid).once("value", function (snapshot) {
                            var data = snapshot.val();
                            vm.name = data.name
                            vm.dbname = data.dbname
                            vm.dbuser = data.dbuser
                            vm.dbpass = data.dbpass
                            vm.level = data.lvl
                            if (data.lvl == 0) {
                                vm.lvl = true
                            }
                            if (data.nestedApi) {
                                vm.apiObject = data.nestedApi
                                vm.apiObjectLength = vm.apiObject.length
                            }
                        }, function (errorObject) {
                            vm.sendNotify(
                                "Error",
                                "Something went wrong",
                                "error",
                                "highlight_off"
                            );
                            return;
                        });
                    }
                });
            },
        },
        watch: {
            $route() {
                const button = this.$refs.menuTop.$el.querySelector(
                    ".vs-navbar--btn-responsive"
                );
                button.click();
            },
        }


    }
</script>